var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/go-top") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/go-top",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,12 C3,7.02822581 7.02822581,3 12,3 C16.9717742,3 21,7.02822581 21,12 C21,16.9717742 16.9717742,21 12,21 C7.02822581,21 3,16.9717742 3,12 Z M8.21127615,13.0488045 L10.8387097,10.3088851 L10.8387097,16.9354839 C10.8387097,17.4181381 11.2270232,17.8064516 11.7096774,17.8064516 L12.2903226,17.8064516 C12.7729768,17.8064516 13.1612903,17.4181381 13.1612903,16.9354839 L13.1612903,10.3088851 L15.7887239,13.0488045 C16.1262168,13.4007923 16.6887168,13.4080574 17.0334748,13.0632994 L17.4290181,12.6641058 C17.7701613,12.322998 17.7701613,11.7713781 17.4290181,11.4338851 L12.6169355,6.61815225 C12.2757923,6.27700904 11.7242077,6.27700904 11.3866794,6.61815225 L6.56733162,11.4338851 C6.22622385,11.7749929 6.22622385,12.3266129 6.56733162,12.6641058 L6.96291031,13.0632994 C7.31128323,13.4080574 7.87378323,13.4007923 8.21127615,13.0488045 Z",
    id: "go-top",
    fill: "#40B3DB",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoTop);
export default __webpack_public_path__ + "static/media/go-top.663b83b4.svg";
export { ForwardRef as ReactComponent };